<div class="w-[411px] h-[576px]">
  <div class="h-[73px] flex items-center justify-between pl-6 border-b pr-1">
    <div class="left">
      <p class="m-0 font-bold text-lg">Move File To</p>
    </div>
    <div class="right">
      <button mat-icon-button (click)="closeDialog()" class="p-0">
        <mat-icon class="w-6 h-6 text-2xl text-[#707070]">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col w-full h-[87%]">
    <div class="px-6">
      <div class="app__discovery--header--search--field my-4 w-full h-9">
        <div class="app__centered-item w-full h-full px-[10px]">
          <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
          <input
            class="h-full w-full ml-2 border-none outline-none text-[13px]"
            type="text"
            [(ngModel)]="searchText"
            placeholder="Search Templates"
            (input)="onInputChange($event.target.value)"
          />
          @if (searchText) {
          <span (click)="clearSearchAction()" class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer">clear</span>
          }
        </div>
      </div>
    </div>
    <div
      class="overflow-y-auto pl-6"
      style="height: calc(100% - 90px)"
      [ngClass]="{
        'pr-6': filesList().length <= 8
      }"
    >
      @for (item of filesList() | filterItemToResolve :searchText ; track item.id; ) {
      <div
        class="flex items-center justify-between mb-[14px]"
        [ngClass]="{
          'mr-6': filesList().length > 8
        }"
      >
        <div class="flex-1 flex items-center gap-2">
          <div class="w-10 h-10">
            <!-- <img [src]="'assets/images/' + item.type + '-small.svg'" alt="icon" /> -->
            <img [src]="item.profile_image_url" alt="icon" class="w-full h-full" />
          </div>
          <div class="flex flex-col w-[85%]">
            <h3 class="font-semibold text-base m-0">{{ item.form_name | truncateStrPipe : 25 }}</h3>
            <p class="m-0 font-medium text-[10px] text-[#707070]">
              {{ item.section_name | truncateStrPipe : 25 }}
            </p>
          </div>
        </div>
        <div class="right flex">
          <button
            class="rounded border border-solid h-[28px] border-[#25508E] w-[56px] bg-transparent text-[#25508E] text-[12px] mb-0 font-semibold hover:bg-[#EBF0FA]"
            (click)="moveVaultFileItem(item)"
          >
            Select
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>
